import createRoute from '@widesk-ui/tools/createRoute';
import TagModel    from '@models/website/TagModel';

const route = createRoute.splitView(
	'configuration/tags',
	'website',
	'TagSplitView',
	TagModel.localize('plural'),
);
export default route;
